var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLatestTransactions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 273,
    viewBox: "0 0 355 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.443 1C296.845 1 301.736 3.18972 305.276 6.73001C308.816 10.2703 311.006 15.1612 311.006 20.5635V201.15C311.006 206.552 308.816 211.443 305.276 214.983C301.736 218.523 296.845 220.713 291.443 220.713H20.5635C15.1612 220.713 10.2703 218.523 6.73001 214.983C3.18972 211.443 1 206.552 1 201.15V20.5635C1 15.1612 3.18972 10.2703 6.73001 6.73001C10.2703 3.18972 15.1612 1 20.5635 1H291.443Z",
    stroke: "#D2DAE4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.879 58.1857H114.043",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.567 130.42H114.043",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.616 94.3029H114.043",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3426 58.1855H38.6719",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3426 130.42H38.6719",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3426 94.3027H38.6719",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3426 166.537H38.6719",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.567 166.537H114.043",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.384 76.2441C295.412 76.2441 315.356 85.0052 329.792 99.1738C344.218 113.332 353.143 132.892 353.143 154.498C353.143 176.105 344.218 195.664 329.792 209.822C315.356 223.991 295.412 232.752 273.384 232.752C251.355 232.752 231.412 223.991 216.976 209.822C202.55 195.664 193.625 176.105 193.625 154.498C193.625 132.892 202.55 113.332 216.976 99.1738C231.412 85.0052 251.355 76.2441 273.384 76.2441Z",
    fill: "white",
    stroke: "#D2DAE4",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.84 285.423V234.257",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.928 234.257V285.423",
    stroke: "#D2DAE4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.384 103.332C287.934 103.332 301.108 109.062 310.643 118.333C320.163 127.588 326.055 140.373 326.055 154.498C326.055 168.623 320.163 181.408 310.643 190.663C301.108 199.934 287.934 205.664 273.384 205.664C258.834 205.664 245.66 199.934 236.125 190.663C226.605 181.408 220.713 168.623 220.713 154.498C220.713 140.373 226.605 127.588 236.125 118.333C245.66 109.062 258.834 103.332 273.384 103.332Z",
    stroke: "#D2DAE4",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLatestTransactions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/latest-transactions.2e87eca39588d41fb769d7962450e67b.svg";